// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchAllDevices, clearDevices, updateDevice, deleteDevice } from '../../redux/slices/DeviceSlice';
// import './AdminCSS/Details.css';
// import DeviceUpdate from './deviceupdate';

// const DeviceDetails = () => {
//   const dispatch = useDispatch();
//   const { devices, loading, error } = useSelector((state) => state.devices);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [formData, setFormData] = useState({ email: '', mac_address: '' });

//   useEffect(() => {
//     dispatch(fetchAllDevices());
//     return () => {
//       dispatch(clearDevices());
//     };
//   }, [dispatch]);

//   const handleUpdateClick = (device) => {
//     setSelectedDevice(device);
//     setFormData({
//       email: device.email || '',
//       mac_address: device.mac_address,
//     });
//   };

//   const handleUpdateSubmit = () => {
//     if (selectedDevice) {
//       dispatch(updateDevice({ deviceData: formData }));
//       setSelectedDevice(null);
//     }
//   };

//   const handleDelete = (deviceId) => {
//     if (window.confirm('Are you sure you want to delete this device?')) {
//       dispatch(deleteDevice(deviceId));
//     }
//   };

//   return (
//     <div className="Devices-page">
//       {loading && <p className="loading-text">Loading...</p>}
//       {error && <p className="error-text">Error: Unable to fetch devices. Please try again later.</p>}

//       {!loading && !error && devices.length > 0 && (
//         <div className='table-scroll-container'>
//           <table className="device-table">
//             <thead>
//               <tr>
//                 <th>Device_ID</th>
//                 <th>Patient_ID</th>
//                 <th>User_Email</th>
//                 <th>Mac_Address</th>
//                 <th>Operations</th>
//               </tr>
//             </thead>
//             <tbody>
//               {devices.map((device) => (
//                 <tr key={device.device_id}>
//                   <td>{device.device_id}</td>
//                   <td>{device.patient_id}</td>
//                   <td>{device.email || "—"}</td>
//                   <td>{device.mac_address}</td>
//                   <td className="operations">
//                     {/* <button className="view-btn" onClick={() => alert(`View ${device.device_id}`)}>View</button> */}
//                     <button className="update-btn" onClick={() => handleUpdateClick(device)}>Update</button>
//                     <button className="delete-btn" onClick={() => handleDelete(device.device_id)}>Delete</button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {!loading && !error && devices.length === 0 && (
//         <p className="empty-text">No devices found.</p>
//       )}

//       {selectedDevice && (
//         <DeviceUpdate 
//           formData={formData}
//           setFormData={setFormData}
//           handleUpdateSubmit={handleUpdateSubmit}
//           setSelectedDevice={setSelectedDevice}
//         />
//       )}
//     </div>
//   );
// };

// export default DeviceDetails;



import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllDevices,
  clearDevices,
  updateDevice,
  deleteDevice
} from '../../redux/slices/DeviceSlice';
import './AdminCSS/Details.css';
import DeviceUpdate from './deviceupdate';

const DeviceDetails = () => {
  const dispatch = useDispatch();
  const { devices, loading, error } = useSelector((state) => state.devices);

  const [selectedDevice, setSelectedDevice] = useState(null);
  const [formData, setFormData] = useState({
    email: '',
    mac_address: '',
    imei_number: ''
  });

  useEffect(() => {
    dispatch(fetchAllDevices());
    return () => {
      dispatch(clearDevices());
    };
  }, [dispatch]);

  const handleUpdateClick = (device) => {
    setSelectedDevice(device);
    setFormData({
      email: device.email || '',
      mac_address: device.mac_address || '',
      imei_number: device.imei_number || ''
    });
  };

  const handleUpdateSubmit = () => {
    if (selectedDevice) {
      dispatch(updateDevice({
        device_id: selectedDevice.device_id,
        deviceData: formData
      }));
      setSelectedDevice(null);
    }
  };

  const handleDelete = (deviceId) => {
    if (window.confirm('Are you sure you want to delete this device?')) {
      dispatch(deleteDevice(deviceId));
    }
  };

  // Helper function to display identifier
  const getDeviceIdentifier = (device) => {
    if (device.mac_address && device.imei_number) {
      return `${device.mac_address} / ${device.imei_number}`;
    }
    if (device.mac_address) return device.mac_address;
    if (device.imei_number) return device.imei_number;
    return "—";
  };

  return (
    <div className="Devices-page">
      {loading && <p className="loading-text">Loading...</p>}
      {error && (
        <p className="error-text">
          Error: Unable to fetch devices. Please try again later.
        </p>
      )}

      {!loading && !error && devices.length > 0 && (
        <div className='table-scroll-container'>
          <table className="device-table">
            <thead>
              <tr>
                <th>Device_ID</th>
                <th>Patient_ID</th>
                <th>User_Email</th>
                <th>Mac_Address / IMEI_Number</th>
                <th>Status</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {devices.map((device) => (
                <tr key={device.device_id}>
                  <td>{device.device_id}</td>
                  <td>{device.patient_id || "—"}</td>
                  <td>{device.email || "—"}</td>
                  <td>{getDeviceIdentifier(device)}</td>
                  <td>{device.status}</td>
                  <td className="operations">
                    <button
                      className="update-btn"
                      onClick={() => handleUpdateClick(device)}
                    >
                      Update
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(device.device_id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && !error && devices.length === 0 && (
        <p className="empty-text">No devices found.</p>
      )}

      {selectedDevice && (
        <DeviceUpdate
          formData={formData}
          setFormData={setFormData}
          handleUpdateSubmit={handleUpdateSubmit}
          setSelectedDevice={setSelectedDevice}
        />
      )}
    </div>
  );
};

export default DeviceDetails;